/* eslint-disable react/prop-types */
import CustomerTableStatic from "components/CustomerTableStatic";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import { setHomePage, useMaterialUIController } from "context";
import { useEffect, useMemo, useRef, useState } from "react";
import { useSetRecoilState } from "recoil";
import { AlertState } from "states";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import {
  ALLVALUE,
  API_ROUTES,
  ID_GROUP_CHUTHE,
  ID_GROUP_HOIDONG,
  ID_GROUP_NUMBER_SEVEN,
  ID_GROUP_PHUONGXA,
  ID_GROUP_CAPTINH,
  ID_GROUP_NUMBER_ONE,
  CODE_QUANGNAM,
} from "../../../utils/constants";
import dayjs from "dayjs";
import useAuth from "hooks/useAuth";
import { Grid } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import SelectCustomer from "components/SelectCustomer";

const dictTrangThai = {
  1: "Chưa công nhận",
  2: "Chờ đánh giá",
  3: "Đã công nhận",
  4: "Hết hiệu lực",
};
const dictColorTrangThai = {
  1: "info",
  2: "warning",
  3: "error",
  4: "primary",
};
const dictHang = {
  hang1: "Hạng 1",
  hang2: "Hạng 2",
  hang3: "Hạng 3",
  hang4: "Hạng 4",
  hang5: "Hạng 5",
};

function ThongKeSanPham() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const axiosPrivateInstance = useAxiosPrivate();
  const setAlert = useSetRecoilState(AlertState);
  const { user } = useAuth();
  const _timeOut = useRef();

  const [tableData, setTableData] = useState({});
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [cloneDataAll, setCloneDataALL] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [optionNhomSanPham, setOptionNhomSanPham] = useState([]);
  const [optionDistrict, setOptionDistrict] = useState([]);
  const [paramsState, setParamsState] = useState({
    nam: null,
    nhomsanpham: ALLVALUE.ma,
    maquan: ALLVALUE.ma,
  });

  useEffect(() => {
    const fetchDataDataNhomSanPham = async () => {
      try {
        const response = await axiosPrivateInstance.get("nhomsanpham");
        setOptionNhomSanPham(response.data["data"]);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    const fetchDataQuanHuyen = async () => {
      try {
        let body = {
          tinh: CODE_QUANGNAM,
          huyen: isGroupNumberSeven ? user?.maquan : undefined,
        };
        const response = await axiosPrivateInstance.get(API_ROUTES.GETHUYEN, {
          params: body,
        });
        setOptionDistrict(response.data);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    fetchDataQuanHuyen();
    fetchDataDataNhomSanPham();
  }, []);

  //Kiểm tra nhóm người dùng với id Group
  const checkGroupUser = (user, idGroup) => {
    let check = false;
    if (user && user.id) {
      if (user?.group?.find((item) => item?.id == idGroup)) {
        check = true;
      }
    }
    return check;
  };
  //Kiểm tra nhóm người dùng là 1
  const isGroupNumberOne = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_ONE);
  }, [user]);
  //Kiểm tra nhóm người dùng là 9
  const isGroupNumberNine = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_CAPTINH);
  }, [user]);
  //kiểm tra nhóm người dùng là 5
  const isGroupOwner = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_CHUTHE);
  }, [user]);
  //kiểm tra nhóm người dùng là 7
  const isGroupNumberSeven = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
  }, [user]);
  //kiểm tra nhóm người dùng là 8
  const isGroupPhuongXa = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_PHUONGXA);
  }, [user]);
  // Lấy toàn bộ dữ liệu
  const fetchData = async (
    { nam, nhomsanpham, maquan },
    { pageIndex, pageSize },
    user
  ) => {
    if (!tableData?.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      const isOwner = checkGroupUser(user, ID_GROUP_CHUTHE);
      const isGroupSeven = checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
      const isGroupHoiDong = checkGroupUser(user, ID_GROUP_HOIDONG);
      let body = {
        maquan:
          isGroupSeven || isGroupHoiDong
            ? user?.maquan
            : maquan == ALLVALUE.ma
            ? undefined
            : maquan,
        username: isOwner ? user?.username : undefined,
        nam: nam && dayjs(nam)?.isValid() ? dayjs(nam)?.get("year") : undefined,
        nhomsanpham: nhomsanpham == ALLVALUE.ma ? undefined : nhomsanpham,
        maphuong: isGroupPhuongXa ? user.maphuong : undefined,
        pageNumber: pageIndex + 1,
        countNumber: pageSize,
      };
      const response = await axiosPrivateInstance.get(
        API_ROUTES.THONGKESANPHAM,
        { params: body }
      );
      const validatedData = validateObjectDuan(response.data.data);
      setTableData(validatedData);
      setRowCount(response?.data?.totalRecord);
    } catch (error) {
      setIsError(true);
      setAlert({
        alert: true,
        message: error?.message || "Lỗi!",
        type: "error",
      });
      console.log(error);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };
  useEffect(() => {
    if (user && user.id) {
      _timeOut.current && clearTimeout(_timeOut.current);
      _timeOut.current = setTimeout(() => {
        fetchData(paramsState, pagination, user);
      }, [300]);
    }
  }, [pagination, user, paramsState]);

  useEffect(() => {
    const fetchDataCloneAll = async ({ nam, nhomsanpham, maquan }, user) => {
      try {
        const isOwner = checkGroupUser(user, ID_GROUP_CHUTHE);
        const isGroupSeven = checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
        const isGroupHoiDong = checkGroupUser(user, ID_GROUP_HOIDONG);
        let body = {
          maquan:
            isGroupSeven || isGroupHoiDong
              ? user?.maquan
              : maquan == ALLVALUE.ma
              ? undefined
              : maquan,
          username: isOwner ? user?.username : undefined,
          nam:
            nam && dayjs(nam)?.isValid() ? dayjs(nam)?.get("year") : undefined,
          nhomsanpham: nhomsanpham == ALLVALUE.ma ? undefined : nhomsanpham,
          maphuong: isGroupPhuongXa ? user?.maphuongh : undefined,
        };
        const response = await axiosPrivateInstance.get(
          API_ROUTES.THONGKESANPHAM,
          { params: body }
        );
        const validatedData = validateObjectDuan(response.data.data);
        setCloneDataALL(validatedData);
      } catch (error) {
        setAlert({
          alert: true,
          message: error?.message || "Lỗi!",
          type: "error",
        });
        console.log(error);
        return;
      }
    };
    if (user && user.id) {
      fetchDataCloneAll(paramsState, user);
    }
  }, [paramsState, user]);

  const validateObjectDuan = (rawData) => {
    const dataFiltered = rawData?.map((item) => {
      let dataEachItem = { ...item };
      const listHang = ["hang1", "hang2", "hang3", "hang4", "hang5"];
      const hangId = listHang?.find((hang) => item?.[hang] == 1);
      if (hangId) {
        dataEachItem["hang_ten"] = dictHang?.[hangId];
      }
      if (item?.trangthaisanpham) {
        dataEachItem["trangthai_ten"] = dictTrangThai?.[item?.trangthaisanpham];
      }
      if (item?.ngaycongnhan) {
        const value = item?.ngaycongnhan;
        dataEachItem["ngaycongnhan_format"] =
          value && dayjs(value).isValid()
            ? dayjs(value).format("DD/MM/YYYY")
            : value;
      }
      dataEachItem["nam"] = String(item?.nam || "");
      const listFieldDelete = [...listHang];
      listFieldDelete?.forEach((field) => delete dataEachItem?.[field]);
      return { ...dataEachItem };
    });
    return dataFiltered;
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "ma",
        header: "Mã",
        size: 120,
      },
      {
        accessorKey: "ten",
        header: "Tên",
        size: 200,
      },
      {
        accessorKey: "nhomsanpham_ten",
        header: "Nhóm sản phẩm",
        size: 200,
      },
      {
        accessorKey: "trangthaisanpham",
        header: "Trạng thái",
        size: 180,
        Cell: ({ cell }) => {
          const idStatus = cell.getValue();
          return (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={dictTrangThai[idStatus]}
                color={dictColorTrangThai[idStatus]}
                variant="gradient"
              />
            </MDBox>
          );
        },
      },
      {
        accessorKey: "hang_ten",
        header: "Hạng",
        size: 120,
      },
      {
        accessorKey: "nam",
        header: "Năm",
        size: 100,
      },
      {
        accessorKey: "ngaycongnhan_format",
        header: "Ngày công nhận",
        size: 120,
      },
      {
        accessorKey: "chuthe_ten",
        header: "Chủ thể",
        size: 200,
      },
    ],
    []
  );

  //filter
  //nam
  const handleChangeDate = (value) => {
    setParamsState((prev) => {
      return {
        ...prev,
        nam: value,
      };
    });
  };
  const handleToClearDate = () => {
    setParamsState((prev) => ({
      ...prev,
      nam: null,
    }));
  };
  //nhomsanPham
  const handleChangeNhomSanPham = (e) => {
    let { value } = e.target;
    setParamsState((prev) => ({
      ...prev,
      nhomsanpham: value,
    }));
  };
  //maquan
  const handleChangeDistrict = (e) => {
    let { value } = e.target;
    setParamsState((prev) => ({
      ...prev,
      maquan: value,
    }));
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        pt={6}
        py={3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.5rem",
          px: 3,
        }}
      >
        <Grid
          container
          spacing={2}
          rowSpacing={2}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid item xs={12} md={6} lg={4}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={paramsState?.nam ? dayjs(paramsState.nam) : null}
                views={["year"]}
                onChange={handleChangeDate}
                slotProps={{
                  textField: {
                    InputLabelProps: { shrink: true },
                    placeholder: "---Chọn năm---",
                    fullWidth: true,
                    inputProps: {
                      readOnly: true,
                    },
                  },
                  field: {
                    clearable: true,
                    onClear: handleToClearDate,
                  },
                }}
                label="Năm"
                sx={{
                  ".MuiInputLabel-shrink": {
                    fontSize: "0.875rem",
                    lineHeight: "1.6",
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <SelectCustomer
              keyValue="nhomsanpham"
              label="Nhóm sản phẩm"
              labelName="ten"
              option={optionNhomSanPham}
              onChange={handleChangeNhomSanPham}
              state={paramsState.nhomsanpham}
              unicode="id"
            />
          </Grid>
          {(isGroupNumberOne || isGroupNumberNine) && (
            <Grid item xs={12} md={4} lg={4}>
              <SelectCustomer
                keyValue="maquan"
                label="Quận huyện"
                labelName="ten"
                option={optionDistrict}
                onChange={handleChangeDistrict}
                state={paramsState.maquan}
                unicode="ma"
              />
            </Grid>
          )}{" "}
        </Grid>
      </MDBox>
      <MDBox py={3}>
        <CustomerTableStatic
          columns={columns}
          data={tableData}
          allData={cloneDataAll}
          isUsingAllData={true}
          isLoading={isLoading}
          isError={isError}
          setPagination={setPagination}
          pagination={pagination}
          isRefetching={isRefetching}
          tableHeaders={[
            "Mã",
            "Tên",
            "Quy cách",
            "Tiêu chuẩn",
            "Quy mô",
            "Nhóm sản phẩm",
            "Trạng thái",
            "Hạng",
            "Năm",
            "Ngày công nhận",
            "Chủ thể",
            "Địa chỉ chủ thể",
            "SĐT chủ thể",
            "Giới tính",
            "Loại hình kinh doanh",
          ]}
          tableKeyValues={[
            "ma",
            "ten",
            "quycach",
            "tieuchuan",
            "quymo",
            "nhomsanpham_ten",
            "trangthai_ten",
            "hang_ten",
            "nam",
            "ngaycongnhan_format",
            "chuthe_ten",
            "chuthe_diachi",
            "chuthe_dienthoai",
            "chuthe_gioitinh",
            "chuthe_loaihinh",
          ]}
          filename={"ThongKeSanPhamOCOP"}
          titleTable={"Thống kê sản phẩm OCOP"}
          colWidths={[
            5, 25, 15, 15, 15, 15, 25, 15, 15, 15, 15, 25, 35, 15, 15, 15,
          ]}
          widthPercentPDF={[4, 8, 8, 8, 8, 8, 5, 5, 5, 8, 8, 5, 5, 5, 5]}
          count={rowCount}
          orientaitionPage={"landscape"}
          dicSizeBreakWord={{
            ma: 5,
            chuthe_dienthoai: 6,
          }}
        />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ThongKeSanPham;
